import http from '@/plugins/api'
import { startLoading } from '@/plugins/loading'
import * as types from './types'

export default {
  async getBrokenLinks({ commit, dispatch }, status) {
    const r = await startLoading(dispatch, 'getBrokenLinks', () =>
      http.get('admin/getBrokenLinks', {
        // the api treats a missing status as "all". grouped collapses the reports filed against
        // one calibration into a single row - the repair queue works a calibration at a time.
        params: status ? { status: status, grouped: true } : { grouped: true }
      })
    )
    commit(types.SET_BROKEN_LINKS, r.data)
    return r.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/repair-links/actions.js